export enum FixedShape {
    Rectangle = "Rectangle",
    Circle = "Circle",
    Triangle = "Triangle"
}